export default __webpack_public_path__ + "static/media/Slide_LifeBridge_Register-02.4bbd177f.png";